// tslint:disable: triple-equals
import React, { useState } from 'react';
import {
  NotificationWrapper,
  StyledCircle,
  Circle,
  NotificationContent,
  NotificationDescription,
  NotificationTitle,
} from './styled.notificationList';
import { Headline5, Body6, Body4, Headline4 } from '../../typography';
import { NotificationTimeStamp } from '../../../../helpers/dates';
import { convertNameInitial } from '../../../../helpers/convertName';
import { MY_ACTIONS_LABELS } from '../../../../enums/MyActions';
import { useNavigate } from 'react-router-dom';
import { INotificationList } from 'src/app/@types/notification';
import { updateNotifications } from '../../../../requests/notifications';
import { SwitchHotelModal } from '../SwitchHotelModal';
import { userHotelDetails } from '../../../../helpers/handleBrandAndHotelData';
import { setItem } from '../../../../utils/localStorage';
import { SetDefaultTemplateId } from '../../../../components/commons/Header/SetDefaultTemplateId';
import { INotificationHotelData } from '../../../../app/@types/switchHotelModal';
import InfiniteScroll from 'react-infinite-scroll-component';
import LoadingContent from 'lqa-ui/lib/Components/LoadingContent';

export function NotificationList ({
  NotificationData,
  fetchNextNotificationData,
  hasMoreNotifications,
}: INotificationList) {
  const navigate = useNavigate();
  const { selectedHotel, allHotels } = userHotelDetails();
  const [showSwitchHotelModal, setShowSwitchHotelModal] =
    useState<boolean>(false);
  const [notificationHotelData, setNotificationHotelData] =
    useState<INotificationHotelData>();

  function navigationHandler (notificationId, redirectUrl) {
    updateNotifications(notificationId).then((response) => {
      const baseUrls = [
        'myLQADeeplink://redirect?test=https://dev-client.leadingquality.io',
        'myLQADeeplink://redirect?test=https://stage-client.leadingquality.io',
        'myLQADeeplink://redirect?test=https://zfxzfgtgvxvmrongyfuh.leadingquality.com',
      ];
      const baseToRemove = baseUrls.find((url: string) =>
        redirectUrl.includes(url)
      );
      if (baseToRemove) {
        const targetUrl = redirectUrl.replace(baseToRemove, '');
        setShowSwitchHotelModal(false);
        navigate(targetUrl);
      }
    });
  }

  function onNotificationClickHandler (notificationItem) {
    if (notificationItem.hotelId == selectedHotel) {
      navigationHandler(notificationItem.id, notificationItem.url);
    } else {
      const switchHotelDetail = allHotels.find(
        (hotel) => parseInt(hotel.id) === parseInt(notificationItem.hotelId)
      );
      const currentHotelDetail = allHotels.find(
        (hotel) => parseInt(hotel.id) === parseInt(selectedHotel)
      );
      setNotificationHotelData({
        switchHotel: switchHotelDetail.name,
        currentHotel: currentHotelDetail.name,
        hotelId: notificationItem.hotelId,
        url: notificationItem.url,
        notificationId: notificationItem.id,
        type: notificationItem.type,
      });
      setShowSwitchHotelModal(true);
    }
  }

  async function switchHotelHandler (hotelId, url, notificationId) {
    const hotelDetails = allHotels.find(
      (hotel) => parseInt(hotel.id) === parseInt(hotelId)
    );
    const selectedBrand = hotelDetails.brandId;
    setItem('selectedBrand', selectedBrand);
    setItem('selectedClient', hotelDetails.clientId);
    setItem('selectedHotel', hotelDetails.id);
    SetDefaultTemplateId(hotelId);
    navigationHandler(notificationId, url);
  }

  const backgroundColorObject = {
    actionPlan: 'denim',
    selfAssessment: 'verdigris',
    myAudit: 'amber',
  };

  return (
    <>
      <InfiniteScroll
        dataLength={NotificationData.length}
        next={fetchNextNotificationData}
        hasMore={hasMoreNotifications}
        loader={<LoadingContent layout="flex" />}
      >
        {NotificationData &&
          NotificationData.map((notification) => {
            return (
              <NotificationWrapper
                key={notification.id}
                isActive={!notification.isRead}
                onClick={() => onNotificationClickHandler(notification)}
              >
                <StyledCircle>
                  <Circle
                    color={backgroundColorObject[notification.type] || 'white'}
                  >
                    <Headline5>
                      {convertNameInitial(notification.sentByUser)}
                    </Headline5>
                  </Circle>
                </StyledCircle>
                <NotificationContent>
                  <NotificationTitle>
                    <Body6 color="verdigris">
                      {MY_ACTIONS_LABELS[notification.type] ||
                        notification.type}
                    </Body6>
                    <Body6 color="battleShipGray">
                      {NotificationTimeStamp(notification.timestamp)}
                    </Body6>
                  </NotificationTitle>
                  <NotificationDescription>
                    {!notification.isRead && (
                      <Headline4>{notification.body}</Headline4>
                    )}
                    {notification.isRead && <Body4>{notification.body}</Body4>}
                  </NotificationDescription>
                </NotificationContent>
              </NotificationWrapper>
            );
          })}
      </InfiniteScroll>
      {showSwitchHotelModal && notificationHotelData && (
        <SwitchHotelModal
          showSwitchHotelModal={showSwitchHotelModal}
          handleModalClose={() => {
            setShowSwitchHotelModal(false);
          }}
          notificationHotelData={notificationHotelData}
          switchHotelHandler={switchHotelHandler}
        />
      )}
    </>
  );
}
